<section id="chartsbg">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Chart Library</h1>
        <a routerLink="/charts"><h5>More Charts</h5></a>
      </div>
    </div>
  </div>
</section>

<section class="section" id="charts">
  <div class="container">
  <div class="row">
  <div class="bigChartWrapper col-12">
    <div class="row">
    <div class="col-lg-12">
        
        <app-chart-embed [id]="chartId"></app-chart-embed>
    </div>
    </div>
  </div>
  </div> 
  </div>
</section>